import { render, staticRenderFns } from "./CalendarCustom.vue?vue&type=template&id=5d45da9a"
import script from "./CalendarCustom.vue?vue&type=script&lang=js"
export * from "./CalendarCustom.vue?vue&type=script&lang=js"
import style0 from "./CalendarCustom.vue?vue&type=style&index=0&id=5d45da9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports